import { PortableTextComponentProps } from '@portabletext/react'
import cx from 'classnames'
import { useContext } from 'react'

import { SanityVideoButton } from '@data/sanity/queries/types/content'
import { SiteContext } from '@lib/site'

import Button, {
  getButtonColor,
  getButtonIconAlignment,
  getButtonSize,
  getButtonVariant,
} from '@components/buttons/button'

type VideoButtonValue = Pick<SanityVideoButton, 'video' | 'text' | 'style'>

const VideoButton = ({
  value,
}: PortableTextComponentProps<VideoButtonValue>) => {
  const { video, text, style } = value

  const { toggleVideoModal } = useContext(SiteContext)

  return (
    <Button
      onClick={() => {
        toggleVideoModal(true, video)
      }}
      variant={getButtonVariant(style?.variant)}
      size={getButtonSize(style?.size)}
      color={getButtonColor(style?.color)}
      icon={style?.icon}
      iconAlignment={getButtonIconAlignment(style?.iconAlignment)}
      className={cx('btn', {
        'w-full': style?.isFullWidth,
      })}
    >
      {text}
    </Button>
  )
}

export default VideoButton
